import { motion } from "framer-motion";
import Reveal from "@/components/Reveal";
import DigitalGlobe from "@/components/DigitalGlobe";
import AMark from "@/components/AMark";
import { Satellite, Signal, Globe2 } from "lucide-react";

const CHIPS = [
  { icon: Satellite, label: "Optical · SAR · Thermal" },
  { icon: Signal, label: "Sub-30 min revisit" },
  { icon: Globe2, label: "Planet-scale, India-tuned" },
];

function EagleGlobeLink() {
  return (
    <div className="relative flex flex-col items-center" data-testid="eagle-globe-link">
      {/* Eagle */}
      <motion.div
        className="relative z-10 h-20 w-24 sm:h-24 sm:w-28"
        animate={{ y: [0, -8, 0] }}
        transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
      >
        <div
          className="absolute inset-0 blur-2xl"
          style={{ background: "radial-gradient(50% 50% at 50% 50%, rgba(0,229,255,0.4), transparent 70%)" }}
        />
        <AMark className="relative h-full w-full text-white drop-shadow-[0_6px_28px_rgba(0,229,255,0.5)]" fill="#ffffff" /> </motion.div>

      {/* Uplink beam connecting eagle -> globe */}
      <div className="relative my-1 h-14 w-8 sm:h-16">
        <div
          className="absolute left-1/2 top-0 h-full w-px -translate-x-1/2"
          style={{ background: "linear-gradient(to bottom, rgba(0,229,255,0.85), rgba(0,229,255,0.05))" }}
        />
        {/* traveling data packets */}
        {[0, 1, 2].map((i) => (
          <motion.span
            key={i}
            className="absolute left-1/2 h-1.5 w-1.5 -translate-x-1/2 rounded-full bg-arjuna-teal"
            style={{ boxShadow: "0 0 8px #00E5FF" }}
            initial={{ top: "0%", opacity: 0 }}
            animate={{ top: ["0%", "100%"], opacity: [0, 1, 1, 0] }}
            transition={{ duration: 1.6, repeat: Infinity, delay: i * 0.55, ease: "easeIn" }}
          />
        ))}
      </div>

      {/* Globe */}
      <div className="relative -mt-2">
        <DigitalGlobe className="h-64 w-64 sm:h-80 sm:w-80" />
      </div>
    </div>
  );
}

export default function GlobalBand() {
  return (
    <section className="relative overflow-hidden bg-arjuna-ink py-24 sm:py-32" data-testid="global-band">
      <div className="absolute inset-0 grid-lines opacity-20" />
      <div className="container-x relative">
        <div className="grid grid-cols-1 items-center gap-16 lg:grid-cols-2">
          <div>
            <Reveal>
              <p className="overline">Global coverage</p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-5 font-heading text-3xl font-medium tracking-tight text-white sm:text-4xl lg:text-5xl">
                From orbit to insight. <span className="text-arjuna-teal">From insight to impact.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-6 max-w-md text-base leading-relaxed text-slate-400">
                A continuous feed from public and tasked earth-observation missions streams
                into our platform. an eagle-eye uplink that focuses planet-scale data onto
                India&apos;s coasts and farmland, resolving change from orbit to the metre.
              </p>
            </Reveal>
            <div className="mt-8 flex flex-wrap gap-3">
              {CHIPS.map((c, i) => (
                <Reveal key={c.label} delay={0.3 + i * 0.08}>
                  <div className="flex items-center gap-2 rounded-full border border-white/10 bg-arjuna-surface/40 px-4 py-2">
                    <c.icon className="h-4 w-4 text-arjuna-teal" />
                    <span className="text-sm text-slate-200">{c.label}</span>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <Reveal delay={0.15} className="flex justify-center">
            <EagleGlobeLink />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
